<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="radioButtonValue"

	[label]="label"
	[type]="'radio'"
	[rule]="''"
	[radios]="[
		{
			label: step2.getoui,
			value: 'Oui'
		},
		{
			label: step2.getnon,
			value: 'Non'
		}
	]"
	[name]="radioButtonCtrlName"
>
</app-form-input>
